<template>
	<!--  <div class="user" @touchstart="fnstart" ref="Element"> -->
	<div class="user">
		<div class="header bg-color-red acea-row row-between-wrapper">
			<div class="picTxt acea-row row-between-wrapper">
				<div class="pictrue"><img src="@assets/images/logo444.jpg" /></div>
				<div class="text">
					<div class="acea-row row-middle">
						<div class="name line1">{{ userInfo.nickname }}</div>

					</div>
					<router-link :to="'/user/data'" class="id">
						ID：{{ userInfo.uid || 0
            }}
					</router-link>

				</div>
			</div>
			<!-- <span class="iconfont icon-shezhi" @click="$router.push({ path: '/user/data' })"></span> -->
		</div>
		<div class="wrapper">
			<div class="nav acea-row row-middle">
				<router-link :to="{ }" class="item">
					<div>总收入</div>
					<div class="num">{{ userInfo.zongshouru || 0 }}</div>
				</router-link>
				<router-link :to="{  }" class="item">
					<div>已提现</div>
					<div class="num">{{ userInfo.tixian || 0 }}</div>
				</router-link>
				<router-link :to="{  }" class="item">
					<div>账户余额</div>
					<div class="num">{{ userInfo.dl_syjf || 0 }}</div>
				</router-link>
				<!--<router-link-->
				<!--:to="'/user/user_promotion'"-->
				<!--class="item"-->
				<!--v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"-->
				<!--&gt;-->
				<!-- <div
          @click="goPagey('/user/user_promotion')"
          class="item"
          v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"
        >
          <div>当前佣金</div>
          <div class="num">{{ userInfo.brokerage_price || 0 }}</div>
        </div> -->

				<!--</router-link>-->

				<!-- <router-link :to="'/user/user_coupon'" class="item">
          <div>优惠券</div>
          <div class="num">{{ userInfo.couponCount || 0 }}</div>
        </router-link> -->
			</div>
			<div class="myOrder" v-if="true">
				<div class="title acea-row row-between-wrapper">
					<div>我的订单</div>

				</div>
				<div class="orderState acea-row row-middle">
					<router-link :to="{ path: '/order/list/' + 0 }" class="item">
						<div class="pictrue">
							<img src="@assets/images/dfk.png" />
							<span class="order-status-num"
								v-if="orderStatusNum.unpaid_count > 0">{{ orderStatusNum.unpaid_count }}</span>
						</div>
						<div>全部订单</div>
					</router-link>
					<router-link :to="{ path: '/order/lists/' + 1 }" class="item">
						<div class="pictrue">
							<img src="@assets/images/dfh.png" />
							<span class="order-status-num"
								v-if="orderStatusNum.unshipped_count > 0">{{ orderStatusNum.unshipped_count }}</span>
						</div>
						<div>有效订单</div>
					</router-link>
					<!-- <router-link :to="{ path: '/order/list/' + 2 }" class="item">
		    <div class="pictrue">
		      <img src="@assets/images/dsh.png" />
		      <span
		        class="order-status-num"
		        v-if="orderStatusNum.received_count > 0"
		        >{{ orderStatusNum.received_count }}</span
		      >
		    </div>
		    <div>提现</div>
			 </router-link> -->
					<!-- <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received_count > 0"
                >{{ orderStatusNum.received_count }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>待评价</div>
          </router-link>
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>售后/退款</div>
          </router-link> -->
				</div>
			</div>
			<div class="myService" v-if="userInfo.real_name && userInfo.phone && userInfo.danwei">
				<div class="title acea-row row-middle">用户菜单</div>
				<div class="serviceList acea-row row-middle">
					<template v-for="(item, index) in MyMenus">
						<div class="item" :key="index" @click="goPages(index)" v-if="item.wap_url">
							<div class="pictrue">
								<img :src="item.pic" />
							</div>
							<div>{{ item.name }}</div>
						</div>
					</template>
					<!--<div-->
					<!--class="item"-->
					<!--@click="changeswitch(true)"-->
					<!--v-if="userInfo.phone && isWeixin"-->
					<!--&gt;-->
					<!--<div class="pictrue"><img src="@assets/images/switch.png" /></div>-->
					<!--<div>账号切换</div>-->
					<!--</div>-->
				</div>
			</div>
		</div>
		<div class="logOut  acea-row row-center-wrapper" @click="logout"
			style="position: fixed;bottom: 2rem;left: 50px;background-color: #ff3700;color: #fff; width: calc(100% - 100px);height: 0.8rem; border-radius: 10px;">
			退出登录
		</div>
		<!-- <img src="@assets/images/support.png" class="support" /> -->
		<div class="footer-line-height"></div>
		<Loading :loaded="loadend" :loading="loading"></Loading>
		<SwitchWindow v-on:changeswitch="changeswitch" :switchActive="switchActive" :login_type="userInfo.login_type">
		</SwitchWindow>
		<GeneralWindow :generalActive="generalActive" @closeGeneralWindow="closeGeneralWindow"
			:generalContent="generalContent"></GeneralWindow>
	</div>

</template>

<script>
	import {
		getUser,
		getMenuUser
	} from "@api/user";
	import {
		isWeixin
	} from "@utils";
	import Loading from "@components/Loading";
	import SwitchWindow from "@components/SwitchWindow";
	import GeneralWindow from "@components/GeneralWindow";
	import {
		getLogout
	} from "@api/user";
	import {
		clearAuthStatus
	} from "@libs/wechat";
	const NAME = "User";

	export default {
		name: NAME,
		components: {
			SwitchWindow,
			Loading,
			GeneralWindow,
		},
		props: {},
		data: function() {
			return {
				userInfo: {},
				MyMenus: [],
				orderStatusNum: {},
				switchActive: false,
				isWeixin: false,
				generalActive: false,
				loadTitle: "",
				loading: false,
				loadend: false,
				generalContent: {
					promoterNum: "",
					title: "",
				},
			};
		},
		watch: {
			$route(n) {
				if (n.name === NAME) this.User();
			},
		},
		mounted: function() {
			this.User();
			this.MenuUser();
			this.isWeixin = isWeixin();
		},
		methods: {
			changeswitch: function(data) {
				this.switchActive = data;
			},
			fnstart(ev) {
				this.$refs["Element"].style.top = 0;
				this.scroolTop =
					0;

				document.ontouchmove = this.fnmove;
				document.ontouchend = this.fnEnd;

			},
			fnmove(ev) {
				let that = this;
				that.loading = true;
				this.T = ev.changedTouches[0].pageY - this.scroolTop;
				if (this.scale > 0.12) {
					this.scale = 1 - this.T / 200;
				} else {
					this.scale = 0.12;
				}
				this.$refs["Element"].style.top = 0;
			},
			fnEnd(ev) {
				let that = this;
				that.loading = false;
				that.loadend = false;
				document.ontouchmove = null;
				document.ontouchend = null;
				setTimeout((that) => {

					this.$refs["Element"].style.top = 0;
					this.$refs["Element"].style.transition = ".3s ease all";
					this.$refs["Element"].addEventListener("transitionend", () => {
						this.$refs["Element"].style.transition = null;
						this.User();
						that.loading = false;
						that.loadend = false;
					});
					this.User();
				}, 500);
			},
			User: function() {
				let that = this;
				getUser().then((res) => {
					that.userInfo = res.data;
					that.orderStatusNum = res.data.orderStatusNum;
					this.generalContent = {
						promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${
            res.data.promoter_price || 0
          }元</span>即可开通推广权限`,
						title: "您未获得推广权限",
					};
				});
			},
			MenuUser: function() {
				let that = this;
				getMenuUser().then((res) => {
					that.MyMenus = res.data.routine_my_menus;
				});
			},
			goPagey(url) {
				if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
					return this.$dialog.toast({
						mes: "您还没有推广权限！！"
					});
				if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
					return (this.generalActive = true);
				}
				this.$router.push({
					path: url
				});
			},
			goPages: function(index) {
				let url = this.MyMenus[index].wap_url;
				if (url === "/user/user_promotion") {
					if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
						return this.$dialog.toast({
							mes: "您还没有推广权限！！"
						});
					if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
						return (this.generalActive = true);
					}
				}
				if (url === "/customer/index" && !this.userInfo.adminid) {
					return this.$dialog.toast({
						mes: "您还不是客服！！"
					});
				}
				this.$router.push({
					path: this.MyMenus[index].wap_url
				});
			},
			closeGeneralWindow(msg) {
				this.generalActive = msg;
			},
			logout: function() {
				this.$dialog.confirm({
					mes: "确认退出登录?",
					opts: () => {
						getLogout()
							.then(res => {
								this.$store.commit("LOGOUT");
								clearAuthStatus();
								location.href = location.origin;
								console.log(res);
							})
							.catch(err => {
								console.log(err);
							});
					}
				});
			}
		},
	};
</script>

<style scoped>
	.footer-line-height {
		height: 1rem;
	}

	.order-status-num {
		min-width: 0.33rem;
		background-color: #fff;
		color: #ee5a52;
		border-radius: 15px;
		position: absolute;
		right: -0.14rem;
		top: -0.15rem;
		font-size: 0.2rem;
		padding: 0 0.08rem;
		border: 1px solid #ee5a52;
	}

	.pictrue {
		position: relative;
	}

	.switch-h5 {
		margin-left: 0.2rem;
	}

	.binding {
		padding: 0.05rem 0.2rem;
		background-color: #ca1f10;
		border-radius: 50px;
		font-size: 0.14rem;
		border: 1px solid #e8695e;
		color: #ffffff;
	}
</style>